import { useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { hasPrivilege } from "../api/token";
import KiwiCard from "../components/KiwiCard";

export default function EditKiwi() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const can_edit = hasPrivilege('assign') || hasPrivilege('manufacture_edit');

  useEffect(() => {
    if (!can_edit) {
      navigate("/");
    }
  }, [navigate, can_edit])

  if (can_edit) {
    const editable = true;
    const ident = params.id;

    return (
      <div>
        <KiwiCard editable={editable} ident={ident} location={location}/>
      </div>
    )
  }
}
